import { ObjectAccess } from 'src/app/shared/models/api';
import { CodeValue } from 'src/app/shared/models/lookups';

export class UserProfile {
	UserProfileId: string;
	Username: string;

	DisplayName: string;
	ContactPhone: string;
	ContactMobile: string;
	ContactEmail: string;
	StatusCode: string;
	StatusName: string;
	UserRoleId: string;
	UserRoleName: string;
	MobileNumber?: string;

	ClientId: string;
	ClientName: string;
	BusinessEntityId: string;
	BusinessEntityName: string;

	CreateNewUserBusinessEntity: boolean;
	NewUserBusinessEntityId: string;

	IsCurrentUser: boolean;
	IsClientUser: boolean;
	IsBusinessEntityUser: boolean;
	IsBusinessEntityNeeded?: boolean;

	LinkedUserBusinessEntityId: string;
	LinkedUserBusinessEntityName: string;

	UserRelationTypeCode: string;
	UserRelationTypeName: string;

	AssetRestrictions: CodeValue[];

	AddedById: string;
	AddedBy: string;
	UpdatedById: string;
	UpdatedBy: string;
	DateAdded: Date;
	DateUpdated: Date;

	AddedByExternalUserRelationTypeCode: string;
	UpdatedByExternalUserRelationTypeCode: string;

	ObjectAccess: ObjectAccess;
}
